import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import logo from "./assets/LogoTransperant.png"; // Update the path if your logo is elsewhere
import Home from "./screens/Home";
import About from "./screens/About";
import Contact from "./screens/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Services from "./screens/Services";
import Products from "./screens/Products";
import Projects from "./screens/Projects";
import Clients from "./screens/Clients";
import Carrer from "./screens/Carrer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <div>
      <Header className="header" />
      <main style={{ padding: "0rem" }}>
        {/* <div
          style={{
            fontWeight: "bold",
            fontSize: "2.5rem",
            fontFamily: "Georgia, serif",
            letterSpacing: "1px",
            color: "#1a237e",
            marginBottom: "0.5rem",
          }}
        >
          Akruthi Engineered Building Solutions
        </div> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/carrer" element={<Carrer />} />
        </Routes>
      </main>
      {/* <BackToTop /> */}
      {/* <ScrollToTopButton /> */}
      <Footer />
      <FloatingButtons />
    </div>
  );
}

// Styles
const headerStyle = {
  background: "#30373e ",
  //background: "#FF8C00",
  color: "#fff",
  padding: "1rem 0",
};

const headerContentStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "0 1rem",
  flexWrap: "wrap", // Allow wrapping on smaller screens
};

const logoContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const logoStyle = {
  height: "80px",
  width: "100px",
  marginRight: "1rem",
};

const titleStyle = {
  fontSize: "1.5rem",
  margin: 0,
};

const navStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap", // Allow wrapping of navigation links
  justifyContent: "center", // Center links on smaller screens
};

const linkStyle = {
  color: "#ffffff",
  marginLeft: "1rem",
  textDecoration: "none",
  fontWeight: "bold",
  fontSize: "0.9rem", // Adjust font size for smaller screens
};

export default App;
